




























































import Vue from 'vue';
import ApiConfiguration from '@/classes/ApiConfiguration';
import { SweepGraphCredentialModel, SweepGraphCredentialUpdateModel } from '@/services/GeneratedApi';
import { ComponentHelper, MTablehelper, RouteHelpers, confirmationHelper } from '@/mixins';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { ConfigurationChangeModel, NotificationPresentationType, StoreConstants, MStoreExceptionResponseModel } from '@/types';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'SweepGraphCredentialsConfiguration',
  mixins: [ComponentHelper, MTablehelper, RouteHelpers, confirmationHelper],

  data() {
    return {
      isLoading: false,
      searchQuery: '',
      pageIsLoading: true,
      showAddCredential: false,
      showEditCredential: false,
      credentials: [] as SweepGraphCredentialModel[],
      updateCredentialModel: 'Add' as 'Add' | 'Edit',
      selectedCredential: {} as SweepGraphCredentialUpdateModel,
      showUpdateModal: false,
      fields: [
        {
          key: 'actions',
          label: '',
          sortable: false,
          thStyle: { width: '120px' },
          tdStyle: { width: '120px' }
        },
        {
          key: 'displayName',
          label: 'Name',
          sortable: true
        },
        {
          key: 'tenantId',
          label: 'Tenant ID',
          sortable: true
        },
        {
          key: 'clientId',
          label: 'Client ID',
          sortable: true
        },
        {
          key: 'activeSourceCount',
          label: 'Active Sources',
          sortable: true
        }
      ]
    };
  },

  methods: {
    ...mapActions(StoreConstants.ConfigurationChange.ModuleName, [
      StoreConstants.ConfigurationChange.Actions.BeginChange,
      StoreConstants.ConfigurationChange.Actions.EndChange,
      StoreConstants.ConfigurationChange.Actions.GetChangeWithErrorPage
    ]),
    async onChangeReasonEntered(this: any, changeReason: string) {
      try {
        await this[StoreConstants.ConfigurationChange.Actions.BeginChange]({
          controllerPath: this.CHANGE_CONTROLLER_PATH,
          configurationChange: {
            description: changeReason
          } as ConfigurationChangeModel
        });
      } catch (error) {
        this.$log(error);
      }
    },
    async onReleaseLock(this: any) {
      await this[StoreConstants.ConfigurationChange.Actions.EndChange](this.CHANGE_CONTROLLER_PATH);
    },
    async initialise(this: any) {
      this.pageIsLoading = true;
      await this.getCredentialsAsync();
      this.resetFilters();
      this.pageIsLoading = false;
    },
    onModalCancelled(this: any) {
      this.showUpdateModal = false;
    },
    async onModalSaved(this: any) {
      this.showUpdateModal = false;
      await this.getCredentialsAsync();
    },
    async getCredentialsAsync(this: any) {
      try {
        this.isLoading = true;
        this.credentials = await ApiConfiguration.apiWithErrorPage().sweepGraphCredentialsConfiguration.sweepGraphCredentialsConfigurationList();
      } catch (error) {
        this.$log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async deleteCredentialAsync(this: any, id: number) {
      try {
        this.isLoading = true;
        await ApiConfiguration.api().sweepGraphCredentialsConfiguration.sweepGraphCredentialsConfigurationDelete(id);
        await this.getCredentialsAsync();
      } catch (error) {
        this.$log(error);
      } finally {
        this.isLoading = false;
      }
    },

    async testCredential(this: any, id: number) {
      try {
        this.isLoading = true;
        await ApiConfiguration.apiWithoutNotification().sweepGraphCredentialsConfiguration.sweepGraphCredentialsConfigurationTestDetail(id);
        SnotifyConfiguration.showSuccess('Credential test successful');
      } catch (error) {
        const exceptionModel: MStoreExceptionResponseModel = error as any;
        const testResultNotification = exceptionModel?.notification ? exceptionModel.notification : 'An error occurred while testing the credentials';
        SnotifyConfiguration.showNotification(testResultNotification, NotificationPresentationType.UserActionRequired);
      } finally {
        this.isLoading = false;
      }
    },

    resetFilters(this: any) {
      this.resetMTableState();
    },

    async onDeleteCredential(this: any, item: any) {
      const confirmed = await this.hasDeleteConfirmedAsync(this.$bvModal, 'Are you sure you want to delete this credential?');
      if (confirmed) {
        await this.deleteCredentialAsync(item.id);
      }
    },

    onEditCredential(this: any, item: any) {
      const updateCredential: SweepGraphCredentialUpdateModel = {
        id: item.id,
        displayName: item.displayName,
        tenantId: item.tenantId,
        clientId: item.clientId,
        clientSecret: ''
      };
      this.selectedCredential = updateCredential;
      this.updateCredentialModel = 'Edit';
      this.showUpdateModal = true;
    },

    onAddCredential(this: any) {
      this.selectedCredential = {
        displayName: '',
        tenantId: '',
        clientId: '',
        clientSecret: ''
      } as SweepGraphCredentialUpdateModel;
      this.updateCredentialModel = 'Add';
      this.showUpdateModal = true;
    },
    onTestCredential(this: any, id: number) {
      this.testCredential(id);
    },
    onSearchQueryUpdate(this: any, key: string, value: string) {
      this.searchQuery = value;
    }
  },
  computed: {
    ...mapGetters(StoreConstants.ConfigurationChange.ModuleName, [
      StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLock,
      StoreConstants.ConfigurationChange.Getters.BypassConfigurationChangeLock,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession,
      StoreConstants.ConfigurationChange.Getters.ConfigurationChangeIsLoading
    ]),
    lock(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLock];
    },
    bypassLockingOnToolkit(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.BypassConfigurationChangeLock];
    },
    isEditMode(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeLockedByCurrentSession];
    },
    isLockLoading(this: any) {
      return this[StoreConstants.ConfigurationChange.Getters.ConfigurationChangeIsLoading];
    }
  },

  mounted() {
    this.initialise();
  },
  created(this: any) {
    this.CHANGE_CONTROLLER_PATH = 'SweepGraphCredentialsConfiguration';
  },

  components: {
    MStoreTable: () => import('@/components/shared/Table/MStoreTable.vue'),
    LoadingSpinner: () => import('@/components/shared/LoadingSpinner.vue'),
    SweepGraphCredential: () => import('@/components/configuration/sweep/SweepGraphCredential.vue'),
    MStoreMakeChangesLock: () => import('@/components/shared/MStoreMakeChangesLock.vue')
  }
});
